<template>
    <div>
        <Topbar/>
        <Sidebar/>

        <NoticeBanner/>

        <router-view></router-view>
    </div>
</template>

<script>
import Topbar from '@/components/common/layout/Topbar';
import Sidebar from '@/components/common/layout/Sidebar';
import NoticeBanner from '@/components/common/layout/NoticeBanner';

    export default {
        name: 'default-layout',
        components: {
            Topbar,
            Sidebar,
            NoticeBanner
        }
    }
</script>
